import { HintData, MessageData, CustomerListEventData } from './chat';
import { PreviewData } from './preview';

/** 本地 socket 事件 */
export enum LocalSocketStatusActions {
  CONNECTED = 'socket_connected',
  DISCONNECTED = 'socket_disconnected',
}

/** 更新用户列表的事件 */
export type CustomerListActions = 'rec_cus' | 'rel_cus' | 'cus_change_archive' | 'redirect_cus';

/** 标签事件 */
export type TagActions = 'cus_tags_unbind' | 'cus_tags_bind';

/** Ai 中断 恢复事件 */
export type AiCutActions = 'cus_auto_disable_ai' | 'cus_delay_auto_enable_ai';

/** 其它 socket 直接推送的事件 */
export type NativeActions =
  | CustomerListActions
  | 'withdraw'
  | 'hint'
  | 'send_msg_failed'
  | 'agent_update_customer_info'
  | 'wechat_copy'
  | 'channel_change_enable_ai'
  | 'cus_change_enable_ai'
  | 'cus_change_enable_workflow'
  | 'channel_gen_done'
  | 'comment_created'
  | 'cus_became_leads'
  | TagActions
  | AiCutActions
  | 'ent_points_used_up'
  | 'announcement'
  | 'customer_create';

/** 预览事件 */
export type PreviewActions =
  | 'preview_knowledge'
  | 'preview_message'
  | 'preview_event'
  | 'preview_done';

export type EventActions =
  | LocalSocketStatusActions
  | 'MESSAGE'
  | 'HINT'
  | 'PREVIEW'
  | PreviewActions
  | NativeActions;

/** 推送数据 */
export type EventData<Action extends EventActions = EventActions, Body = any> = {
  action: Action;
  createdAt: number;
  entId: number;
  id: string;
  targetId: string;
  targetKind: 'customer' | 'channel';
  body: Body;
  opAgentInfo?: { id: number; name: string };
};
export type EventsRecord<
  Action extends EventActions = EventActions,
  Data extends EventData = EventData,
> = Record<Action, Data>;

export type MessageEvents = EventsRecord<'MESSAGE', MessageData>;
export type HintEvents = EventsRecord<'HINT', HintData>;
export type PreviewEvents = EventsRecord<'PREVIEW', PreviewData>;
export type PreviewActionsEvents = EventsRecord<PreviewActions, PreviewData>;

export type TransferEvents = EventsRecord<CustomerListActions, CustomerListEventData>;
export type NativeEvents = EventsRecord<NativeActions, EventData>;

export type LocalSocketEvents = EventsRecord<LocalSocketStatusActions, any>;

export type EmitterEvents = MessageEvents &
  HintEvents &
  PreviewEvents &
  PreviewActionsEvents &
  TransferEvents &
  NativeEvents &
  LocalSocketEvents;
